import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { AccountsgroupService } from "./shared/accountsgroup.service";

@Component({
  selector: 'app-accountsgroup',
  templateUrl: './accountsgroup.component.html',
  styleUrls: ['./accountsgroup.component.css']
})
export class AccountsgroupComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  AccountsGroupList: any[] = [];
  btnvisibility: boolean = true;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    public accountsgroupService: AccountsgroupService,) { }

  ngOnInit() {
   
    // initialization
    this.resetForm();
    this.GetAccountsgroupList();
    this.AddButtonText = "Save";
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.accountsgroupService.selectedAccountsgroup = {
      Id: null,
      AccountId: null,
      ParentAccountId: 0,
      AccountGroupName: null,
      DispalyOrder: null,
      DisplayIn: "BS",
      GroupCode: null,
      Predefined: null,
      IsActive: true,
      Flag:1
    }
  }

  GetAccountsgroupList() {
    this.accountsgroupService.FetchVoucherList().subscribe(data => {
      // console.log(data);
      this.AccountsGroupList = data;
    })
  }

  public onSubmit(form: NgForm) {

    this.accountsgroupService.IUDAccountsGroup(this.accountsgroupService.selectedAccountsgroup)
    .toPromise()
    .then(data => {
      this.router.navigate(['/accountsgrouplist']);
    })
    .catch(err => { console.log(err) });

  }

}
